import {
  BASIC_INFO,
  GET_RESTAURANT,
  SET_BANK_INFO,
  SET_DOCUMENTS,
  SET_MEALS,
  SET_PLANS,
  SET_RESTAURANT,
  EDIT_BASIC_INFO,
  EDIT_PAPERS,
  EDIT_MEALS,
  SET_PROFIT_MARGINS,
  SET_ID,
  SET_RESTAURANT_ID
} from "../utilities/constants";
import { restaurant, profit_margins } from "../models/model";
const initialState = {
  restaurant, profit_margins
}

export default function RestaurantReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case SET_ID:
      return { ...state, id: payload }
    case SET_RESTAURANT_ID:
      return { ...state, restaurant_id: payload }
    case BASIC_INFO:
      return { ...state, ...payload };
    case EDIT_BASIC_INFO:
      return { ...state, ...payload };
    case EDIT_PAPERS:
      return { ...state, ...payload };
    case EDIT_MEALS:
      return { ...state, ...payload };
    case SET_DOCUMENTS:
      return { ...state, ...payload };
    case SET_MEALS:
      return { ...state, ...payload };
    case SET_PLANS:
      return { ...state, ...payload };
    case SET_BANK_INFO:
      return { ...state, ...payload };
    case SET_RESTAURANT:
      return { ...state, ...payload };
    case GET_RESTAURANT:
      return { ...state, ...payload };
    case SET_PROFIT_MARGINS:
      return { ...state, profit_margins: payload };
    default:
      return state;
  }
}
